import { useCallback } from 'react'

import {
  useFileUploader,
  useImageUploader,
} from '@tribeplatform/react-sdk/hooks'

import { ChatAttachment } from '../types.js'

export const useUploadAttachments = () => {
  const { uploadFile } = useFileUploader()
  const { uploadImage } = useImageUploader()

  const uploadAttachments = useCallback(
    async (attachments: ChatAttachment[]) => {
      const uploadedAttachments = await Promise.all(
        attachments.map(async att => {
          if (att.type === 'image' || att.type === 'giphy') {
            const uploadedFile = await uploadImage(att.file)
            return {
              ...att,
              uploadedFile,
            }
          }
          const uploadedFile = await uploadFile(att.file)
          const uploadedAttachment: ChatAttachment = {
            ...att,
            uploadedFile,
          }

          return uploadedAttachment
        }),
      )
      return uploadedAttachments
    },
    [uploadFile, uploadImage],
  )

  return { uploadAttachments }
}
